import { camelToSnake } from '../../utils/object'

/**
 * A class that provides reusable methods for client-side model classes
 */
export default class Model {
  // Placeholder for the create method.
  static create() {
    throw Error(
      'NOT IMPLEMENTED: The `create()` method should be implemented ' +
        'on subclasses of the `Model` class.',
    )
  }

  // Placeholder for the fromAPI method.
  static fromAPI() {
    throw Error(
      'NOT IMPLEMENTED: The `fromAPI()` method should be implemented ' +
        'on subclasses of the `Model` class.',
    )
  }

  /**
   * Prepare a model object to be sent to the API.
   *
   * @param {Object} obj             Instance of a sub-class of `Model`.
   * @param {Array}  fields          Array of fields to include in the API data.
   * @param {Array}  excludeFields   Array of fields to exclude from the API data.
   */
  static toAPI(obj, fields = [], excludeFields = []) {
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = obj[field]
      })
    } else {
      // By default, send everything
      data = obj
    }

    // Remove read-only fields and explicitly excluded fields.
    excludeFields = [...obj.constructor.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return camelToSnake(data)
  }
}
